import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { IStackTokens, Stack } from "@fluentui/react/lib/Stack";
import { Label } from "@fluentui/react/lib/Label";
import { IconButton } from "@fluentui/react/lib/Button";
import {
  Dropdown,
  DropdownMenuItemType,
  IDropdownStyles,
  IDropdownOption,
  IDropdownProps,
} from "@fluentui/react/lib/Dropdown";
import { AppStateContext } from "../../state/AppProvider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  alpha,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputBase,
  InputLabel,
  MenuProps,
  Popover,
  Radio,
  RadioGroup,
  Select,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UserGuideIcon from "../../assets/guide-book.png";
import GPTIcon from "../../assets/GPT.svg";
import GeminiIcon from "../../assets/Gemini.svg";
import GrookIcon from "../../assets/Grook.svg";
import CloudeIcon from "../../assets/Cloude.svg";
import { Height } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import MyProfile from "../../pages/MyProfile";
import { Tooltip as ReactTooltip } from "react-tooltip";

// import Word2Img from '../../assets/word.png'
// import PDFIMG from "../../assets/pdf.png";
// import TextIMG from '../../assets/file.png'

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const ExportIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5C4 4.44772 4.44772 4 5 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H5C4.44772 20 4 19.5523 4 19V5ZM5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H17C18.6569 22 20 20.6569 20 19V5C20 3.34315 18.6569 2 17 2H5Z"
      fill="currentColor"
    />
    <path
      d="M14 8C14.5523 8 15 8.44772 15 9V15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8Z"
      fill="currentColor"
    />
    <path
      d="M9 11C9.55228 11 10 11.4477 10 12V15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15V12C8 11.4477 8.44772 11 9 11Z"
      fill="currentColor"
    />
  </svg>
);

const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    display: "flex",
    marginRight: "15px",
    alignItems: "center",
  },
  label: {
    marginRight: "10px",
    color: "#72767a",
  },
  title: {
    borderColor: "#cacaca !important",
    height: "36px",
    lineHeight: "33px",
    borderRadius: "4px",
  },
  caretDown: {
    height: "36px",
    lineHeight: "35px !important",
  },
  dropdown: {
    width: 150,
  },
};

const divStyle = {
  display: "flex",
};

const DocIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 4.5V14.5H3.5V1.5H8"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 1.5L12.5 4.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 1.5V4.5"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 4.5H8"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.5 8.5H8"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.5 10.5H10"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const FinanceIcon = () => (
  <svg
    xmlns="
      http://www.w3.org/2000/svg"
    data-name="Layer 2"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="green"
  >
    <g data-name="Layer 1">
      <path d="m1,23V0H0v24h24v-1H1ZM22,2h-4v20h4V2Zm-1,19h-2V3h2v18Zm-4-15h-4v16h4V6Zm-1,15h-2V7h2v14Zm-4-10h-4v11h4v-11Zm-1,10h-2v-9h2v9Zm-4-5H3v6h4v-6Zm-1,5h-2v-4h2v4Z" />
    </g>
  </svg>
);

const PolicyIcon = () => (
  <svg
    data-name="Layer 2"
    xmlns="
    http://www.w3.org/2000/svg"
    viewBox="0 0 21 25"
    width="16"
    height="16"
    fill="blue"
  >
    <g data-name="Layer 1">
      <path d="m2,0v2H0v1h2v2H0v1h2v2H0v1h2v2H0v1h2v2H0v1h2v2H0v1h2v2H0v1h2v2H0v1h2v1h19V0H2Zm18,24H3V1h17v23Zm-5-9h-7v1h7v-1Zm0,3h-7v1h7v-1Z" />
    </g>
  </svg>
);

const ProfileIcon = () => (
  <svg
    data-name="Layer 2"
    xmlns="
    http://www.w3.org/2000/svg"
    viewBox="0 0 20 24.22"
    width="16"
    height="16"
  >
    <g data-name="Layer 1">
      <path d="m17.66,15.17l-4.84-1.61c-.3-.1-.62.07-.72.38-.1.31.07.65.37.74l4.84,1.61c1.07.36,1.79,1.38,1.79,2.55l-.1,4.37h-3v-4h-1v4H5v-4h-1v4H1l-.09-4.37c0-1.17.72-2.19,1.79-2.55l4.95-1.65c.3-.1.47-.43.37-.74-.1-.31-.42-.48-.72-.38l-4.95,1.65C.81,15.68,0,17.53,0,19.22v5h20v-5c0-1.69-.79-3.54-2.34-4.05Zm-7.59-2.69c2.74,0,4.87-3.82,4.87-7.1S12.94,0,10.07,0s-4.87,2.21-4.87,5.38,2.13,7.1,4.87,7.1Zm0-11.29c2.23,0,3.73,1.68,3.73,4.19,0,2.66-1.72,5.91-3.73,5.91s-3.73-3.23-3.73-5.91c0-2.51,1.5-4.19,3.73-4.19Z" />
    </g>
  </svg>
);

const HrIcon = () => (
  <svg
    data-name="Layer 2"
    xmlns="
    http://www.w3.org/2000/svg"
    viewBox="0 0 20 26.22"
    width="16"
    height="16"
    fill="red"
  >
    <g data-name="Layer 1">
      <path d="m17.66,15.17l-4.84-1.61c-.3-.1-.62.07-.72.38-.1.31.07.65.37.74l4.84,1.61c1.07.36,1.79,1.38,1.79,2.55l-.1,6.37h-2l.05,1h2.95v-7c0-1.69-.79-3.54-2.34-4.05ZM.91,18.85c0-1.17.72-2.19,1.79-2.55l4.95-1.65c.3-.1.47-.43.37-.74-.1-.31-.42-.48-.72-.38l-4.95,1.65C.81,15.68,0,17.53,0,19.22v7h3v-1H1l-.09-6.37Zm9.16-6.37c2.74,0,4.87-3.82,4.87-7.1S12.94,0,10.07,0s-4.87,2.21-4.87,5.38,2.13,7.1,4.87,7.1Zm0-11.29c2.23,0,3.73,1.68,3.73,4.19,0,2.66-1.72,5.91-3.73,5.91s-3.73-3.23-3.73-5.91c0-2.51,1.5-4.19,3.73-4.19Zm-5.07,17.03h-1v6h12v-6H5Zm10,5H5v-4h10v4Zm-11,3h12v-1H4v1Z" />
    </g>
  </svg>
);

const AllIcon = () => (
  <svg
    id="a"
    xmlns="
    http://www.w3.org/2000/svg
    "
    viewBox="0 0 42.43 38.5"
    width="16"
    height="16"
    fill="#da2128"
  >
    <path d="M0,13.87c1.43-1.66,2.86-3.33,4.29-4.99C6.7,6.09,9.11,3.3,11.52.51c.57-.65.73-.67,1.38-.11,1.19,1.03,2.39,2.05,3.57,3.09.23.2.4.23.68.1,2.28-1.05,4.56-2.09,6.84-3.13.7-.32.88-.25,1.21.46.66,1.44,1.32,2.88,1.97,4.33.12.27.26.37.55.36.98-.02,1.96,0,2.94-.01.34,0,.6.09.85.34,1.44,1.45,2.88,2.9,4.33,4.33.23.22.3.47.3.78,0,2.57,0,5.14,0,7.7,0,.15,0,.3,0,.43.64.05,1.24.04,1.83.15,2.38.42,4.13,2.38,4.43,4.88.26,2.25-1.09,4.61-3.21,5.53-.32.14-.42.29-.42.63.02,1.59.01,3.17,0,4.76,0,1.98-1.34,3.34-3.32,3.34-7.98,0-15.96,0-23.94,0-1.99,0-3.32-1.35-3.32-3.33,0-4.45,0-8.89,0-13.34,0-.31-.09-.51-.32-.7-2.49-2.14-4.97-4.29-7.46-6.44-.14-.12-.28-.26-.42-.39,0-.14,0-.28,0-.41ZM31.79,22.56c-.19,0-.34,0-.49,0-3.05,0-6.1,0-9.15,0-.19,0-.39,0-.58-.04-.61-.09-1.11-.41-1.54-.83-1.14-1.1-2.28-2.21-3.42-3.32-.37-.36-.78-.59-1.32-.58-1.41.01-2.82,0-4.22,0-1.1,0-1.71.64-1.71,1.74,0,5.21,0,10.41,0,15.62,0,1.35.81,2.18,2.16,2.18,7.98,0,15.96,0,23.94,0,1.33,0,2.16-.85,2.16-2.19,0-1.5,0-3.01,0-4.52v-.39c-4.24.41-7.39-3.55-5.82-7.68ZM18.37,6.8c-.02.08-.04.12-.04.16,0,3.75,0,7.51,0,11.26,0,.12.07.27.15.36.8.8,1.62,1.58,2.43,2.36.32.31.7.46,1.16.46,3.37,0,6.73,0,10.1-.01.17,0,.39-.11.51-.25.56-.61,1.19-1.12,1.95-1.43.27-.11.33-.25.33-.52,0-2.46,0-4.91,0-7.37,0-.13-.02-.26-.03-.42-1.02,0-2,0-2.98,0-.7,0-1.22-.35-1.48-1-.1-.26-.13-.56-.14-.85-.02-.91,0-1.82,0-2.75h-11.97ZM17.17,17.33c0-.28,0-.45,0-.61,0-3.35,0-6.71,0-10.06,0-.96.1-1.06,1.08-1.06,2.43,0,4.86,0,7.29,0,.16,0,.31-.01.52-.02-.62-1.35-1.2-2.64-1.8-3.96-5.06,2.31-10.09,4.6-15.14,6.9,1.21,2.66,2.4,5.28,3.61,7.9.05.1.23.19.35.19.56.02,1.13.02,1.7,0,.84-.03,1.66.04,2.41.71ZM12.29,1.4C8.64,5.62,5.03,9.8,1.4,13.99c2.26,1.95,4.48,3.88,6.76,5.85.03-2.26,1.2-3.25,3.34-3.23-.08-.19-.14-.33-.2-.47-1.13-2.48-2.26-4.97-3.39-7.45-.26-.57-.17-.81.41-1.07,1.54-.7,3.08-1.41,4.63-2.11.87-.4,1.75-.8,2.68-1.22-1.12-.97-2.2-1.91-3.33-2.88ZM36.91,20.38c-2.43,0-4.37,1.94-4.37,4.36,0,2.4,1.94,4.36,4.32,4.37,2.43,0,4.39-1.96,4.4-4.39,0-2.38-1.97-4.34-4.35-4.34ZM33.96,10.24c-.81-.81-1.63-1.64-2.45-2.47,0,.64-.01,1.33,0,2.01,0,.28.19.45.49.45.67,0,1.35,0,1.96,0Z" />
    <path d="M23.49,33.72c3.52,0,7.04,0,10.56,0,.12,0,.25,0,.37,0,.41.02.63.21.65.55.01.35-.22.58-.64.61-.1,0-.19,0-.29,0-7.11,0-14.22,0-21.33,0-.18,0-.4.04-.52-.05-.18-.13-.37-.35-.4-.55-.04-.27.16-.49.46-.54.15-.02.3-.02.45-.02,3.56,0,7.12,0,10.69,0Z" />
    <path d="M15.28,29.76c.9,0,1.79,0,2.69,0,.46,0,.7.21.71.57,0,.36-.25.59-.7.59-1.81,0-3.61,0-5.42,0-.43,0-.7-.25-.69-.6.01-.33.27-.55.69-.56.91,0,1.82,0,2.73,0Z" />
    <path d="M26.64,19.23c-1.92,0-3.84,0-5.76,0-.18,0-.41.02-.52-.08-.15-.14-.32-.38-.3-.56.02-.18.24-.36.41-.48.11-.07.29-.03.45-.03,3.82,0,7.65,0,11.47,0,.07,0,.14,0,.21,0,.42.02.68.22.69.56.01.35-.26.6-.69.6-1.99,0-3.98,0-5.96,0Z" />
    <path d="M26.67,15.25c1.91,0,3.81,0,5.72,0,.14,0,.28,0,.41.01.3.04.47.24.48.53.01.29-.14.51-.43.57-.15.03-.3.04-.45.04-3.82,0-7.65,0-11.47,0-.15,0-.31,0-.45-.03-.31-.07-.47-.29-.44-.61.03-.3.2-.49.51-.51.33-.02.66-.01.99-.01,1.71,0,3.42,0,5.14,0Z" />
    <path d="M26.67,13.58c-1.92,0-3.84,0-5.76,0-.15,0-.31,0-.45-.03-.29-.07-.48-.29-.41-.57.06-.2.26-.38.44-.52.09-.07.27-.03.4-.03,3.84,0,7.68,0,11.51,0,.01,0,.03,0,.04,0,.56,0,.84.19.85.57,0,.39-.28.59-.87.59-.79,0-1.57,0-2.36,0-1.13,0-2.26,0-3.4,0Z" />
    <path d="M24.44,10.76c-1.17,0-2.34,0-3.52,0-.15,0-.34.04-.44-.04-.18-.13-.41-.34-.41-.52,0-.18.2-.41.37-.55.11-.09.32-.05.48-.05,2.34,0,4.69,0,7.03,0,.08,0,.17,0,.25,0,.42.03.65.25.64.6-.01.34-.23.55-.64.55-.9.01-1.79,0-2.69,0-.36,0-.72,0-1.08,0Z" />
    <path d="M35.89,25.76c.39-.42.72-.79,1.06-1.14.67-.68,1.34-1.35,2.02-2.02.29-.28.64-.29.88-.04.23.24.22.57-.05.85-1.16,1.17-2.32,2.33-3.48,3.48-.3.3-.59.29-.91-.02-.48-.46-.94-.93-1.41-1.4-.28-.29-.3-.64-.05-.88.25-.25.57-.23.88.07.33.33.65.67,1.06,1.1Z" />
  </svg>
);

const WordIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.01 17.94"
    width="20"
    height="20"
    fill="red"
    style={{ marginRight: "7px" }}
  >
    <defs></defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <polygon
        className="cls-1"
        points="20.01 1.96 20.01 16.03 11.96 16.03 11.96 13.99 17.96 13.99 17.96 11.99 11.96 11.99 11.96 9.99 17.96 9.99 17.96 7.99 11.96 7.99 11.96 5.99 17.96 5.99 17.96 3.99 11.96 3.99 11.96 1.96 20.01 1.96"
      />
      <path
        className="cls-1"
        d="m0,2v13.94l9.97,2V0L0,2Zm7.22,10.15h-1.47l-.69-3.92-.84,3.92h-1.54l-1.41-7.06h1.23l.96,4.85,1.04-4.85h1.23l.76,4.37.79-4.37h1.18l-1.24,7.06Z"
      />
    </g>
  </svg>
);

const PDFIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.03 20"
    width="20"
    height="20"
    style={{ marginRight: "7px" }} // Add margin-right
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        className="cls-1"
        d="m0,0v20h16.03V6.17L9.88,0H0Zm14.03,18H2V2h7l.05,4.98,4.98.04v10.97Z"
      />
      <path
        className="cls-2"
        d="m12.47,12.86c0,.56-.77,1.02-1.72,1.02-.51,0-.98-.13-1.29-.35-.61-.21-1.06-.67-1.39-1.24-.27.71-.62,1.3-.91,1.73.01.01.02.02.02.03.21.52-.32,1.24-1.2,1.6-.88.37-1.76.24-1.98-.27-.21-.52.32-1.24,1.2-1.6.37-.15.73-.22,1.05-.21.43-.62,1.06-1.71,1.23-3-.04-.19-.06-.39-.08-.58-.24-.31-.4-.81-.4-1.36,0-.95.46-1.72,1.02-1.72s1.01.77,1.01,1.72c0,.65-.21,1.21-.52,1.5,0,.14-.01.27-.02.4.11.57.32,1.19.7,1.62.04.05.09.1.14.13.31-.26.83-.43,1.42-.43.95,0,1.72.45,1.72,1.01Z"
      />
    </g>
  </svg>
);

const Word2: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <a
    href="https://www.flaticon.com/free-icons/microsoft-word"
    title="microsoft word icons"
  ></a>
);

const TextIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.03 20"
    width="20"
    height="20"
    style={{ marginRight: "7px" }}
  >
    <defs></defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <rect className="cls-1" x="4" y="10" width="8.03" height="2.05" />
      <rect className="cls-1" x="4" y="14" width="8.03" height="2.05" />
      <rect className="cls-1" x="4" y="10" width="8.03" height="2.05" />
      <rect className="cls-1" x="4" y="14" width="8.03" height="2.05" />
      <rect className="cls-1" x="4" y="10" width="8.03" height="2.05" />
      <rect className="cls-1" x="4" y="14" width="8.03" height="2.05" />
      <path
        className="cls-1"
        d="m0,0v20h16.03V6.17L9.88,0H0Zm14.03,18H2V2h7l.05,4.98,4.98.04v10.97Z"
      />
    </g>
  </svg>
);

const GptIcon = (props: any) => (
  <svg
    id="Layer_1"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 256 256"
    style={{
      enableBackground: "new 0 0 256 256",
    }}
    xmlSpace="preserve"
    width="16"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#10A37F;width:16px !important;}\n\t.st1{fill:#10A37F;}\n"
      }
    </style>
    <path className="st0" d="M-128-128" />
    <path
      className="st1"
      d="M238.1,108.5c-1.7-2.1-2.4-3.9-1.5-6.6c1.7-5.1,2.2-10.4,2.2-15.8c0.1-37.2-33.3-66.6-70.7-62 c-4.3,0.5-7.4,0.2-10.3-3.3c-1.9-2.3-4.6-4-7.1-5.7C116.6-7.6,71.5,6.1,55.9,43.7c-0.9,2.3-2.1,3.8-4.7,4.5 c-44.6,12-61.9,63.8-33.2,99.5c1.7,2.2,2.1,4,1.3,6.7c-2.4,7.8-2.9,16-1.6,24c5.8,35.6,36.6,58.1,73,53.3c2.3-0.3,3.7,0.1,5.4,1.7 c33.5,32.1,86.2,21.3,104-21.3c1-2.4,2.3-3.6,4.8-4.3C249.2,195.9,266.6,143.8,238.1,108.5z M154.4,44.7c15.9-8.2,32.2-7,47,3 c14.8,10,21.9,24.3,20.8,42.2c-0.2,3.2-0.8,4-3.9,2.1c-15.2-8.8-30.6-17.4-45.8-26.2c-4.4-2.6-8.2-2.6-12.7-0.1 c-18.1,10.5-36.4,20.8-54.6,31.2c-1.2,0.7-2.5,1.3-4.4,2.3c0-7.8,0.1-14.9,0-22c0-1.9,0.7-2.9,2.3-3.7 C120.1,63.9,137,53.8,154.4,44.7z M155.2,128c0,3.9-0.2,7.8,0.1,11.7c0.2,2.8-0.7,4.4-3.3,5.8c-7.2,3.8-14.2,7.9-21.2,12 c-2,1.2-3.6,1.2-5.6,0c-7.1-4.2-14.3-8.3-21.6-12.3c-1.9-1.1-3-2.2-2.9-4.7c0.2-8.3,0.1-16.7,0-25c0-2.1,0.6-3.4,2.5-4.5 c7.4-4.1,14.7-8.2,22-12.5c2-1.2,3.6-1.2,5.6,0c7.1,4.2,14.3,8.3,21.6,12.3c2.3,1.2,3,2.7,2.9,5.1C155.1,119.9,155.2,124,155.2,128z  M68.2,61.6c3.1-34.6,44.1-52.9,73-33.1c1,0.7,2.1,1.5,3.6,2.5c-8.9,5.1-17.5,10-26.1,14.9c-7.8,4.5-15.6,9-23.6,13.4 c-4.1,2.3-6,5.3-6,10.1c0.1,20.9,0.1,41.8,0.1,62.8c0,1.4,0,2.8,0,4.9c-7.2-4.1-13.7-7.8-20.2-11.5c-1.2-0.7-1.5-1.6-1.5-2.9 C67.9,102.2,66.4,81.8,68.2,61.6z M42.7,69.2c2.4-1.6,5.5-4.2,7.7-3.2c2.4,1,0.9,4.9,0.9,7.6c0.1,15.9,0.2,31.7,0,47.6 c-0.1,5.3,1.9,8.6,6.5,11.1C76,142.4,94,152.7,112.1,163c1.3,0.7,2.5,1.5,4.3,2.6c-6.7,3.8-12.9,7.3-19.1,10.9c-1.7,1-3.1,0.9-4.8,0 c-16.1-9.3-32.5-18.2-48.5-27.8C13.1,130.2,12.5,88.8,42.7,69.2z M54.2,208c-14.7-9.9-21.2-24-20.4-41.5c0.2-3.7,0.8-4.4,4.3-2.4 c14.9,8.7,30.1,17.1,45.1,25.8c4.7,2.7,8.7,2.8,13.5,0.1c18.1-10.5,36.4-20.8,54.6-31.2c1.1-0.6,2.3-1.2,4-2.1c0,8,0,15.4,0,22.9 c0,1.4-0.9,2-1.9,2.6c-17.2,9.7-34.2,20-51.8,29C85.5,219.5,69.1,218.1,54.2,208z M187.7,194.1c-1.6,18.2-12.1,31.1-29,38 c-16.7,6.9-32.6,3.9-47.7-7.1c6.3-3.6,12.1-7,18-10.4c10.5-6,20.9-12,31.5-17.9c4.3-2.4,6.2-5.5,6.1-10.5 c-0.2-20.6-0.1-41.2-0.1-61.9c0-1.6,0-3.1,0-5.5c7.1,4,13.3,7.6,19.7,11.2c1.5,0.8,2,1.9,2,3.5C188,153.8,189.4,174.1,187.7,194.1z  M235,153.2c-2,16.6-11.4,28.6-26.6,36.2c-3.3,1.7-3.8,0.6-3.8-2.6c0.1-17.2-0.1-34.3,0.1-51.5c0.1-5.6-1.9-9-6.9-11.8 c-18.5-10.2-36.7-20.8-55.1-31.2c-0.9-0.5-1.7-1.1-3.2-2c6.8-3.8,13.2-7.4,19.4-11c1.5-0.9,2.6-0.8,4,0c17.4,10,35.2,19.4,52.1,30.2 C230.9,119.6,237.2,135,235,153.2z"
    />
  </svg>
);

const iconStyle = {
  width: "20px",
  height: "20px",
  marginRight: "7px",
  fontSize: "14px",
};

// const ExportOptions: IDropdownOption[] = [
//   { key: 'Word', text: 'Word', data: { icon: <img src={Word2Img} alt="Word" style={iconStyle} /> } },
//   { key: 'PDF', text: 'PDF', data: { icon: <img src={PDFIMG} alt="Word" style={iconStyle} /> } },
//   { key: 'Text', text: 'Text', data: { icon: <img src={TextIMG} alt="Word" style={iconStyle} /> } },
// ];

const options: any = [
  { key: "GPT4oMini", text: "GPT-4o Mini", data: { icon: <GptIcon /> } },
  { key: "GPT4o", text: "GPT-4o", data: { icon: <GptIcon /> } },
  { key: "GPT4", text: "GPT4", data: { icon: <GptIcon /> } },
  // { key: 'Cloude', text: 'Cloude', data: { icon: <CloudeIcon /> } }

  // { key: 'GenieDocs', text: 'GenieDocs', data: { icon: <DocIcon /> } },
  // { key: 'Bard', text: 'Gemini', data: { icon: <BardIcon /> } },
];

const stackTokens: IStackTokens = { childrenGap: 20 };

const getModelBrandIcon = (model: any): string | null => {
  const source = `${model?.Name || ""} ${
    model?.Display_Name || ""
  }`.toLowerCase();

  if (source.includes("grok")) return GrookIcon;
  if (source.includes("gemini") || source.includes("banana")) return GeminiIcon;
  if (source.includes("gpt")) return GPTIcon;
  if (source.includes("claude")) return CloudeIcon;

  return null;
};

const renderModelIndicatorContent = (model: any) => {
  const icon = getModelBrandIcon(model);

  if (icon) {
    return (
      <img
        src={icon}
        alt={`${model?.Display_Name || model?.Name || "Model"} icon`}
        className="modelBrandIcon"
      />
    );
  }

  return <span>{model?.Model_id}</span>;
};
const iconStyles = { marginRight: "8px" };

// const [categoryData, setCategoryData] = useState<any[]>([]);
// const onRenderLabel = (props: IDropdownProps): JSX.Element => {
//   return (
//     <Stack horizontal verticalAlign="center">
//       <Label>{props.label}</Label>
//       <IconButton
//         iconProps={{ iconName: 'Info' }}
//         title="Info"
//         ariaLabel="Info"
//         styles={{ root: { marginBottom: 0 } }}
//       />
//     </Stack>
//   );
// };

// @ts-ignore
const optionIco: any = {
  display: "inline-flex",
  alignItems: "center",
  marginRight: "6px",
  position: "relative",
  top: "3px",
};

const onRenderOption: any = (option: IDropdownOption): JSX.Element => {
  // @ts-ignore

  return (
    <div>
      {option.data && option.data.icon && (
        <span style={optionIco} title={option.text} className="drpOptionIco">
          {option.data.icon}
        </span>
      )}
      <span>{option.text}</span>
    </div>
  );
};

// @ts-ignore
const onRenderTitle: any = (options: IDropdownOption[]): JSX.Element => {
  const option = options[0];

  return (
    <div>
      {option.data && option.data.icon && (
        <span style={optionIco} title={option.text} className="drpOptionIco">
          {option.data.icon}
        </span>
      )}
      <span>{option.text}</span>
    </div>
  );
};

export const ModelDropdown: React.FunctionComponent = () => {
  const appStateContext = useContext(AppStateContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [models, setModels] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const navigate = useNavigate();

  const [isMyProfileOpen, setIsMyProfileOpen] = React.useState(false);
  const [myProfileInitialSection, setMyProfileInitialSection] = React.useState<
    "usage" | "modelDetails"
  >("usage");
  const [myProfileInitialModelTab, setMyProfileInitialModelTab] =
    React.useState<"subscribed" | "available">("subscribed");
  const openMyProfile = (
    section: "usage" | "modelDetails" = "usage",
    modelTab: "subscribed" | "available" = "subscribed",
  ) => {
    setMyProfileInitialSection(section);
    setMyProfileInitialModelTab(modelTab);
    setIsMyProfileOpen(true);
  };
  const closeMyProfile = () => setIsMyProfileOpen(false);

  const handleBackClick = () => {
    navigate("/my-profile");
  };

  const handleRadioChange = (event: any) => {
    const selectedModel = event.target.value;
    if (!selectedModel) return;

    // Reset App when a Model is chosen
    appStateContext?.dispatch({ type: "RESET_APP" });

    // Update Dropdown with Model
    appStateContext?.dispatch({
      type: "DROPDOWN_ITEM",
      payload: selectedModel,
    });
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const sortedModels = appStateContext?.state.modelDetails || [];
    if (sortedModels.length === 0) return;

    const modelOnly = sortedModels.filter((m: any) => m.Category === "Model");
    const appOnly = sortedModels.filter((m: any) => m.Category === "App");

    appStateContext?.dispatch({
      type: "SET_MODEL_CATEGORY",
      payload: modelOnly,
    });
    appStateContext?.dispatch({
      type: "SET_APP_CATEGORY",
      payload: appOnly,
    });
    setModels(sortedModels);

    const defaultModel = sortedModels.find(
      (model: any) =>
        model.Category === "Model" &&
        model.Model_Selection_Type === "default" &&
        model.Is_Enabled === 1,
    );

    if (defaultModel) {
      appStateContext?.dispatch({
        type: "SET_DEFAULT_MODEL",
        payload: defaultModel,
      });

      if (!appStateContext?.state.selectedAI) {
        appStateContext?.dispatch({
          type: "DROPDOWN_ITEM",
          payload: defaultModel.Name,
        });
      }
    }
  }, [appStateContext?.state.modelDetails]);

  // useEffect(() => {
  //   if (models.length === 0) {
  //     // Only call the API if models haven't been fetched yet
  //     const fetchModelDetails = async () => {
  //       const userName = localStorage.getItem("userId") || "";
  //       const domain = localStorage.getItem("domain") || "";

  //       try {
  //         const response = await fetch("/get_model_details", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ UserName: userName, Domain: domain }),
  //         });

  //         if (!response.ok) {
  //           throw new Error("Network response was not ok");
  //         }

  //         const data = await response.json();
  //         const sortedModels = data.sort(
  //           (a: any, b: any) => a.Display_Seq - b.Display_Seq
  //         );
  //         setModels(sortedModels);

  //         const defaultModel = sortedModels.find(
  //           (model: { Model_Selection_Type: string }) =>
  //             model.Model_Selection_Type === "default"
  //         );
  //         if (defaultModel) {
  //           appStateContext?.dispatch({
  //             type: "SET_DEFAULT_MODEL",
  //             payload: defaultModel,
  //           });

  //           if (!appStateContext?.state.selectedAI) {
  //             appStateContext?.dispatch({
  //               type: "DROPDOWN_ITEM",
  //               payload: defaultModel.Name,
  //             });
  //           }
  //         } else {
  //           console.log("No default model found");
  //         }
  //       } catch (error) {
  //         console.error("Error fetching model details:", error);
  //       }
  //     };

  //     fetchModelDetails();
  //   }
  // }, [models]);

  const defaultModels = models.filter(
    (model) =>
      model.Model_Selection_Type === "default" && model.Is_Enabled === 1,
  );

  //console.log("defaultModels", defaultModels);

  const enabledModels = models.filter(
    (model) =>
      model.Is_Enabled === 1 && model.Model_Selection_Type !== "default",
  );

  //console.log("enabledModels", enabledModels);

  const disabledModels = models.filter((model) => model.Is_Enabled === 0);

  const visibleModels = [
    ...defaultModels,
    ...enabledModels,
    ...disabledModels.filter(
      (model) => model.Model_Selection_Type !== "default",
    ),
  ];

  //console.log("visibleModels", visibleModels);

  const hiddenModels = [
    ...(defaultModels ? [defaultModels] : []),
    ...enabledModels,
  ].slice(3);

  const selectedAI = appStateContext?.state.selectedAI;
  const selectedModelObj = visibleModels.find((m) => m.Name === selectedAI);
  // console.log(selectedModelObj);
  const multiModalModel = visibleModels.find(
    (model) => model.Name === "MultiModel",
  );

  const filteredModels = visibleModels.filter(
    (model) => model.Name !== "MultiModel",
  );
  // start
  // const selectedAI = appStateContext?.state.selectedAI;

  const selectedModel = visibleModels.find((m) => m.Name === selectedAI);
  const popoverOpen = Boolean(anchorEl);
  const popoverId = popoverOpen ? "model-popover" : undefined;
  const handleClick = (e: {
    currentTarget: React.SetStateAction<HTMLElement | null>;
  }) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  //end

  const modelOnly = appStateContext?.state.modelCategory || [];
  const appOnly = appStateContext?.state.appCategory || [];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          whiteSpace: "nowrap",
        }}
      >
        {/* <Typography variant="body1" sx={{ minWidth: "auto" }}>
    Select Model
  </Typography> */}

        {/* <StyledMenu  id="demo-customized-menu"
 
        anchorEl={anchorEl} open={false}>
       
     
 
 
   
    </StyledMenu> */}

        {/* new dropdown*/}

        <Typography
          className="LipiModalDropdown-wrapper"
          onClick={handleClick}
          sx={{
            cursor: "pointer",
            padding: "0.5rem 1rem",
            border: "1px solid #ccc",
          }}
        >
          <div
            className={`modelOption-indicator ${
              modelOnly.some(
                (a: any) => a.Name === appStateContext?.state.selectedAI,
              )
                ? appStateContext?.state.selectedAI
                : "selModalIndicator"
            }`}
          >
            {selectedModelObj ? (
              renderModelIndicatorContent(selectedModelObj)
            ) : (
              <span></span>
            )}
          </div>
          <div className="modelNameDisplay">
            {modelOnly.find(
              (m: any) => m.Name === appStateContext?.state.selectedAI,
            )?.Display_Name || "Select Model"}
          </div>

          <span className="lipimodalArrowIcon">
            <svg
              fill="currentColor"
              width="100%"
              height="100%"
              aria-hidden="true"
              viewBox="0 0 24 24"
            >
              <path d="m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71"></path>
            </svg>
          </span>
        </Typography>

        <Popover
          className="LipiModal_Popover"
          id={popoverId}
          open={popoverOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <div className="visibleModel">
            {multiModalModel && (
              <div
                className={`multimodalwrapper ${
                  selectedAI === multiModalModel.Name ? "active" : ""
                }`}
                onClick={() => {
                  handleRadioChange({
                    target: { value: multiModalModel.Name },
                  } as any);
                  handleClose();
                }}
                style={{ cursor: "pointer" }}
              >
                <span
                  className="infoIcon"
                  data-tooltip-id="multimodalinfo-tooltip"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 256 256"
                    height="20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z"></path>
                  </svg>
                </span>
                <ReactTooltip
                  id="multimodalinfo-tooltip"
                  place="right"
                  className="customTooltip"
                  content="Lipi-4oMini, Lipi-DALL-E, WebSearch"
                />
                <div className="modelOption-content">
                  <div className="modelOption-content-title">
                    <div className="modelOption-indicator LipiMM">
                      <span>{multiModalModel.Model_id}</span>
                    </div>
                    <div className="modelOption-names">
                      <span className="modelName">
                        {multiModalModel.Display_Name}
                      </span>
                      <span className="tokens">100000 tokens per day</span>
                    </div>
                  </div>
                  <div className="multimodalInfoWrapper">
                    {selectedAI === multiModalModel.Name && (
                      <span className="arrowIcon">
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="20"
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"></path>
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* <div className="multimodalwrapper active">
              <span
                className="infoIcon"
                data-tooltip-id="multimodalinfo-tooltip"
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 256 256"
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z"></path>
                </svg>
              </span>
              <ReactTooltip
                id="multimodalinfo-tooltip"
                place="right"
                className="customTooltip"
                content="Lipi-4oMini, Lipi-4o, Lipi-DALL-E"
              />
              <div className="modelOption-content">
                <div className="modelOption-content-title">
                  <div className="modelOption-indicator LipiMM">
                    <span>MM</span>
                  </div>
                  <div className="modelOption-names">
                    <span className="modelName">Multi Modal</span>
                    <span className="tokens">100000 tokens per day</span>
                  </div>
                </div>
                <div className="multimodalInfoWrapper">
                  <span className="arrowIcon">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 24 24"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div> */}

            <div className="specificModalWrapper">
              <div className="model_customApp-wrapper">
                <div className="specificModal">
                  {/* <div className="selectSpecificModal">
                    Select Specific Model:
                  </div> */}

                  <div className="lipiModelOptionWrapper">
                    {modelOnly
                      ?.filter((model) => model.Name !== "MultiModel")
                      .map((model) => {
                        const isSelected = selectedAI === model.Name;
                        const isDisabled = model.Is_Enabled === 0;
                        const modelLabel = `${model.Name || ""} ${
                          model.Display_Name || ""
                        }`.toLowerCase();
                        const isComingSoonModel =
                          modelLabel.includes("grok") ||
                          modelLabel.includes("claude") ||
                          modelLabel.includes("cloude");
                        const isLockedModel = isDisabled || isComingSoonModel;
                        const lockedLabels = [
                          ...(isComingSoonModel ? ["Coming Soon"] : []),
                          ...(isDisabled ? ["Upgrade"] : []),
                        ];
                        return (
                          <Box
                            key={model.ID}
                            onClick={() => {
                              if (isComingSoonModel) {
                                return;
                              }
                              if (isDisabled) {
                                openMyProfile("modelDetails", "available");
                                handleClose();
                                return;
                              }
                              handleRadioChange({
                                target: { value: model.Name },
                              } as any);
                              handleClose();
                            }}
                            className={`modelOption ${
                              isSelected ? "active" : ""
                            } ${isComingSoonModel ? "disabled" : ""}`}
                            sx={{
                              cursor: "pointer",
                              padding: "0.5rem",
                              opacity: isComingSoonModel ? 0.55 : 1,
                            }}
                          >
                            <div className="modelOption-content">
                              <div className="modelOption-content-title">
                                <div
                                  className={`modelOption-indicator ${model.Name}`}
                                >
                                  {renderModelIndicatorContent(model)}
                                </div>
                                <div className="modelOption-names">
                                  <span className="modelName">
                                    {model.Display_Name}
                                  </span>
                                  <span className="tokens">
                                    {model.Token_Limit_Per_Day} tokens per day
                                  </span>
                                  {lockedLabels.length > 0 && (
                                    <div
                                      className="lockedStateText"
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        flexWrap: "wrap",
                                        marginTop: "6px",
                                      }}
                                    >
                                      {lockedLabels.map((label) => (
                                        <span
                                          key={label}
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            borderRadius: "999px",
                                            background: "#4a4a4a",
                                            color: "#fff",
                                            fontSize: "10px",
                                            fontWeight: 600,
                                            lineHeight: 1,
                                            padding: "4px 8px",
                                            textTransform: "none",
                                          }}
                                        >
                                          {label}
                                        </span>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {isSelected && !isLockedModel && (
                                <span className="arrowIcon">
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 24 24"
                                    height="20"
                                    width="20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"></path>
                                  </svg>
                                </span>
                              )}
                            </div>
                          </Box>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <hr className="lipimodel-hr" />
          <div className="subscribe-modal-wrapper">
            To Explore the Other Models
            <button
              className="subscribe-btn"
              onClick={() => openMyProfile("modelDetails", "available")}
            >
              Subscribe
            </button>
          </div> */}
        </Popover>
        <MyProfile
          isOpen={isMyProfileOpen}
          onDismiss={closeMyProfile}
          initialSection={myProfileInitialSection}
          initialModelTab={myProfileInitialModelTab}
        />
        {/* new dropdown end */}
      </Box>
    </>
  );
};

export const AppDropDown: React.FunctionComponent = () => {
  const appStateContext = useContext(AppStateContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [models, setModels] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const navigate = useNavigate();

  const [isMyProfileOpen, setIsMyProfileOpen] = React.useState(false);
  const [myProfileInitialSection, setMyProfileInitialSection] = React.useState<
    "usage" | "modelDetails"
  >("usage");
  const [myProfileInitialModelTab, setMyProfileInitialModelTab] =
    React.useState<"subscribed" | "available">("subscribed");
  const openMyProfile = (
    section: "usage" | "modelDetails" = "usage",
    modelTab: "subscribed" | "available" = "subscribed",
  ) => {
    setMyProfileInitialSection(section);
    setMyProfileInitialModelTab(modelTab);
    setIsMyProfileOpen(true);
  };
  const closeMyProfile = () => setIsMyProfileOpen(false);

  const handleBackClick = () => {
    navigate("/my-profile");
  };

  const handleRadioChange = (event: any) => {
    const selectedApp = event.target.value;
    if (!selectedApp) return;

    if (selectedApp === "HazardDetection") {
      const hazardWindow = window.open(
        "/hazar_detection",
        "hazardDetectionWindow",
      );
      hazardWindow?.focus();
      return;
    }

    //   if (selectedApp === "MappingBuddy") {

    //   appStateContext?.dispatch({ type: "RESET_APP" });

    //   // appStateContext?.dispatch({ type: "DROPDOWN_ITEM", payload: selectedApp });

    //   window.open("/field-mapping", "_blank");

    //   return;
    // }

    appStateContext?.dispatch({ type: "SELECT_APP", payload: selectedApp });
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (models.length === 0) {
      const getModelDetails = async () => {
        try {
          const sortedModels = appStateContext?.state.modelDetails || [];

          const modelOnly = sortedModels.filter(
            (m: any) => m.Category === "Model",
          );
          const appOnly = sortedModels.filter((m: any) => m.Category === "App");

          appStateContext?.dispatch({
            type: "SET_MODEL_CATEGORY",
            payload: modelOnly,
          });
          appStateContext?.dispatch({
            type: "SET_APP_CATEGORY",
            payload: appOnly,
          });

          setModels(sortedModels);

          const defaultModel = sortedModels.find(
            (model: { Model_Selection_Type: string }) =>
              model.Model_Selection_Type === "default",
          );

          if (defaultModel) {
            appStateContext?.dispatch({
              type: "SET_DEFAULT_MODEL",
              payload: defaultModel,
            });

            if (!appStateContext?.state.selectedAI) {
              appStateContext?.dispatch({
                type: "DROPDOWN_ITEM",
                payload: defaultModel.Name,
              });
            }
          } else {
            //  console.log("No default model found");
          }
        } catch (error) {
          console.error("Error fetching model details:", error);
        }
      };

      getModelDetails();
    }
  }, [models]);

  //   if (models.length === 0) {
  //     // Only call the API if models haven't been fetched yet
  //     const fetchModelDetails = async () => {
  //       const userName = localStorage.getItem("userId") || "";
  //       const domain = localStorage.getItem("domain") || "";

  //       try {
  //         const response = await fetch("/get_model_details", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ UserName: userName, Domain: domain }),
  //         });

  //         if (!response.ok) {
  //           throw new Error("Network response was not ok");
  //         }

  //         const data = await response.json();
  //         const sortedModels = data.sort(
  //           (a: any, b: any) => a.Display_Seq - b.Display_Seq
  //         );
  //         setModels(sortedModels);

  //         const defaultModel = sortedModels.find(
  //           (model: { Model_Selection_Type: string }) =>
  //             model.Model_Selection_Type === "default"
  //         );
  //         if (defaultModel) {
  //           appStateContext?.dispatch({
  //             type: "SET_DEFAULT_MODEL",
  //             payload: defaultModel,
  //           });

  //           if (!appStateContext?.state.selectedAI) {
  //             appStateContext?.dispatch({
  //               type: "DROPDOWN_ITEM",
  //               payload: defaultModel.Name,
  //             });
  //           }
  //         } else {
  //           console.log("No default model found");
  //         }
  //       } catch (error) {
  //         console.error("Error fetching model details:", error);
  //       }
  //     };

  //     fetchModelDetails();
  //   }
  // }, [models]);

  const defaultModels = models.filter(
    (model) =>
      model.Model_Selection_Type === "default" && model.Is_Enabled === 1,
  );

  const enabledModels = models.filter(
    (model) =>
      model.Is_Enabled === 1 && model.Model_Selection_Type !== "default",
  );

  //console.log("enabledModels", enabledModels);

  const disabledModels = models.filter((model) => model.Is_Enabled === 0);

  const visibleModels = [
    ...defaultModels, // correct spread here
    ...enabledModels,
  ];

  //console.log("visibleModels", visibleModels);

  const hiddenModels = [
    ...(defaultModels ? [defaultModels] : []),
    ...enabledModels,
  ].slice(3);

  const selectedAI = appStateContext?.state.selectedAI;

  const multiModalModel = visibleModels.find(
    (model) => model.Name === "MultiModel",
  );

  const filteredModels = visibleModels.filter(
    (model) => model.Name !== "MultiModel",
  );

  const selectedModel = visibleModels.find((m) => m.Name === selectedAI);
  const popoverOpen = Boolean(anchorEl);
  const popoverId = popoverOpen ? "model-popover" : undefined;
  const handleClick = (e: {
    currentTarget: React.SetStateAction<HTMLElement | null>;
  }) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  //end

  const modelOnly = appStateContext?.state.modelCategory;
  const appOnly = appStateContext?.state.appCategory || [];

  const openMyFieldMapping = () => {
    window.open("/field-mapping", "_blank");
  };

  const selectedmodel = appOnly.find((m: any) => m.Name === selectedAI);
  useEffect(() => {
    if (selectedmodel?.Name === "MappingBuddy") {
      openMyFieldMapping();
    }
  }, [selectedmodel]);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          whiteSpace: "nowrap",
        }}
      >
        <Typography
          className="LipiModalDropdown-wrapper"
          onClick={handleClick}
          sx={{
            cursor: "pointer",
            padding: "0.5rem 1rem",
            border: "1px solid #ccc",
          }}
        >
          <div
            className={`modelOption-indicator ${
              appOnly.some(
                (a: any) => a.Name === appStateContext?.state.selectedAI,
              )
                ? appStateContext?.state.selectedAI
                : "selAppIndicator"
            }`}
          >
            {selectedmodel ? (
              renderModelIndicatorContent(selectedmodel)
            ) : (
              <span></span>
            )}
          </div>
          <div className="modelNameDisplay">
            {appOnly.find(
              (a: any) => a.Name === appStateContext?.state.selectedAI,
            )?.Display_Name || "Select App"}
          </div>

          <span className="lipimodalArrowIcon">
            <svg
              fill="currentColor"
              width="100%"
              height="100%"
              aria-hidden="true"
              viewBox="0 0 24 24"
            >
              <path d="m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71"></path>
            </svg>
          </span>
        </Typography>

        <Popover
          className="LipiModal_Popover"
          id={popoverId}
          open={popoverOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <div className="visibleModel">
            <div
              className="specificModalWrapper"
              style={{ paddingLeft: "0", border: "0" }}
            >
              <div className="model_customApp-wrapper">
                <div className="customApp">
                  {/* <div className="selectSpecificModal">Select Custom App:</div> */}
                  <div className="lipiModelOptionWrapper">
                    {appOnly?.map((model) => {
                      const isSelected = model.Name === selectedAI;
                      const isDisabled = model.Is_Enabled === 0;
                      const appLabel = `${model.Name || ""} ${
                        model.Display_Name || ""
                      }`.toLowerCase();
                      const isComingSoonApp =
                        appLabel.includes("grok") ||
                        appLabel.includes("claude") ||
                        appLabel.includes("cloude");
                      const isLockedApp = isDisabled || isComingSoonApp;
                      const lockedLabels = [
                        ...(isComingSoonApp ? ["Coming Soon"] : []),
                        ...(isDisabled ? ["Upgrade"] : []),
                      ];

                      return (
                        <Box
                          key={model.ID}
                          onClick={() => {
                            if (isComingSoonApp) {
                              return;
                            }
                            if (isDisabled) {
                              openMyProfile("modelDetails", "available");
                              handleClose();
                              return;
                            }
                            handleRadioChange({
                              target: { value: model.Name },
                            } as any);
                            handleClose();
                          }}
                          className={`modelOption ${
                            isSelected ? "active" : ""
                          } ${isComingSoonApp ? "disabled" : ""}`}
                          sx={{
                            cursor: "pointer",
                            padding: "0.5rem",
                            opacity: isComingSoonApp ? 0.55 : 1,
                          }}
                        >
                          <div className="modelOption-content">
                            <div className="modelOption-content-title">
                              <div
                                className={`modelOption-indicator ${model.Name}`}
                              >
                                {renderModelIndicatorContent(model)}
                              </div>

                              <div className="modelOption-names">
                                <span className="modelName">
                                  {model.Display_Name}
                                </span>
                                <span className="tokens">
                                  {model.Token_Limit_Per_Day} tokens per day
                                </span>
                                {lockedLabels.length > 0 && (
                                  <div
                                    className="lockedStateText"
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      flexWrap: "wrap",
                                      marginTop: "6px",
                                    }}
                                  >
                                    {lockedLabels.map((label) => (
                                      <span
                                        key={label}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          borderRadius: "999px",
                                          background: "#4a4a4a",
                                          color: "#fff",
                                          fontSize: "10px",
                                          fontWeight: 600,
                                          lineHeight: 1,
                                          padding: "4px 8px",
                                          textTransform: "none",
                                        }}
                                      >
                                        {label}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>

                            {isSelected && !isLockedApp && (
                              <span className="arrowIcon">
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 24 24"
                                  height="20"
                                  width="20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"></path>
                                </svg>
                              </span>
                            )}
                          </div>
                        </Box>
                      );
                    })}
                  </div>
                </div>
                {/* Custome app section */}
              </div>
            </div>
          </div>
          {/* <hr className="lipimodel-hr" />
          <div className="subscribe-modal-wrapper">
            To Explore the Other Models
            <button
              className="subscribe-btn"
              onClick={() => openMyProfile("modelDetails", "available")}
            >
              Subscribe
            </button>
          </div> */}
        </Popover>
        <MyProfile
          isOpen={isMyProfileOpen}
          onDismiss={closeMyProfile}
          initialSection={myProfileInitialSection}
          initialModelTab={myProfileInitialModelTab}
        />
        {/* new dropdown end */}
      </Box>
    </>
  );
};

export const SunDropdownAi: React.FunctionComponent = () => {
  const appStateContext = useContext(AppStateContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const handleSubDropdownChange = (event: any, suboptions: any) => {
    //const subselectedAI = suboptions.text;
    const subselectedAI = suboptions.key;

    appStateContext?.dispatch({
      type: "SUBDROPDOWN_ITEM",
      payload: subselectedAI,
    });

    if (isMobile) {
      const subselectedAI = suboptions.key;
      appStateContext?.dispatch({
        type: "SUBDROPDOWN_ITEM",
        payload: subselectedAI,
      });
    }
  };
  return (
    <Stack tokens={stackTokens}>
      <Dropdown
        placeholder="Select an option"
        defaultSelectedKey="azureblob-index-all"
        onRenderTitle={onRenderTitle}
        onRenderOption={onRenderOption}
        options={options}
        styles={dropdownStyles}
        onChange={handleSubDropdownChange}
      />
    </Stack>
  );
};
